import React from "react";

import Button from "../../UI/Button";
import Modal from "../../UI/Modal";

export interface ConfirmModalProps {
  id?: string;
  title: string;
  message?: string | React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onConfirm: () => void;
  cancelText?: string;
  confirmText?: string;
  confirmClassName?: string;
  showCancel?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  id,
  title,
  message,
  isOpen,
  onClose,
  isLoading = false,
  onConfirm,
  cancelText = "No, Cancel",
  confirmText = "Confirm",
  confirmClassName = "button warning",
  showCancel = true,
}) => {
  const modelId = id || `${title.replace(/\s+/g, '-').toLowerCase()}-confirm-modal`;
  return (
    <Modal
      id={modelId}
      title={title}
      className="small padding-horizontal-5"
      visible={isOpen}
      onClose={onClose}
    >
      {isOpen && (
        <div className="row">
          <div className="column">
            <div className="margin-bottom-4">
              {message && <p>{message}</p>}
            </div>
            <div className="row justify-content-between margin-top-4">
              {showCancel && (
                <div className="column-auto">
                  <Button
                    id="cancel-confirm-modal"
                    className="secondary"
                    text={cancelText}
                    disabled={isLoading}
                    onClick={onClose}
                  />
                </div>
              )}
              <div className="column-auto">
                <Button
                  id="confirm-confirm-modal"
                  text={confirmText}
                  className={confirmClassName}
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmModal;
